function rateHoverHandler() {
    const selector = '.circle-buttons > span';
    $(selector).hover(function() {
        if ($(this).siblings('input').val() === '0') {
            highlightCircle($(this));
        }
    });
}

function rateMouseleaveHandler() {
    const selector = '.circle-buttons';
    $(selector).off('mouseleave');
    $(selector).on('mouseleave', function() {
        if ($(this).children('input').val() === '0') {
            $(this).children().removeClass('full');
        }
    });
}

function rateClickHandler() {
    const selector = '.circle-buttons > span';
    $(selector).off('click');
    $(selector).on('click', function() {
        $(this).siblings('input').val($(this).index());
        highlightCircle($(this));
        hideIfRatingsIsValid();
    });
}

function highlightCircle(element) {
    $(element).siblings().removeClass('full');
    $(element).addClass('full');
    $(element).prevAll('span').addClass('full');
}

function validateRatings() {
    const isValid = isRatingsValid();

    if (isValid) {
        $('#ratingsValidationMessage').hide();
    } else {
        $('#ratingsValidationMessage').show();
    }

    return isValid;
}

function hideIfRatingsIsValid() {
    const isValid = isRatingsValid();
    if (isValid) {
        $('#ratingsValidationMessage').hide();
    }
}

function isRatingsValid() {
    let isValid = true;
    $('.circle-buttons > input').each(function() {
        if ($(this).val() === '0') {
            isValid = false;
        }
    });

    return isValid;
}

const initRatings = () => {
    rateHoverHandler();
    rateMouseleaveHandler();
    rateClickHandler();
};

export {
    initRatings
};
